import React, { useEffect } from 'react';
import './countDown.scss';
import { useCounter } from '@hook/useCounter';
import dayjs from 'dayjs';
const CountDownPush = ({ variation }) => {
  const duration = variation?.timerTemplate?.duration || 0;
  const endTime = dayjs(variation?.timerTemplate?.endTime).diff(dayjs());
  const endTimeInSeconds = Math.floor(endTime.valueOf() / 1000);
  const { timer, reset } = useCounter({
    duration:
      variation?.timerTemplate?.countDownType === 'END_TIME'
        ? Math.max(endTimeInSeconds, 0)
        : duration || 0,
    local: 'sticky_countdown',
    immediate: true,
    isShowHours: true,
  });

  useEffect(() => {
    reset(true, true);
  }, []);

  return (
    <div className="wrapper">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <span className="title-counter">
          {variation?.subject || 'Exclusive offer!'}
        </span>
        <span
          style={{ color: variation?.timerTemplate?.timeColor }}
          className="timer-counter"
        >
          {timer}
        </span>
      </div>
      <span className="timer-desc-counter">
        {variation?.message || 'Recharge Your wallet in the next 2 hours...'}
      </span>
    </div>
  );
};

export { CountDownPush };
